import { useQuery } from '@tanstack/react-query';
import fetchApi from './fetchApi';

interface FetchBookingsOptions {
  from?: Date;
  to?: Date;
  organizerId?: number;
  roomId?: number;
}

const useBookingsQuery = (variables?: FetchBookingsOptions, options?: { enabled?: boolean }) => {
  const queryParameters = new URLSearchParams();
  if (variables?.from) {
    queryParameters.append('from', variables.from.toISOString());
  }
  if (variables?.to) {
    queryParameters.append('to', variables.to.toISOString());
  }
  if (variables?.organizerId) {
    queryParameters.append('organizer_id', String(variables.organizerId));
  }
  if (variables?.roomId) {
    queryParameters.append('room_id', String(variables.roomId));
  }

  return useQuery({
    queryKey: ['bookings', queryParameters.toString()],
    queryFn: () => fetchApi<Odoo.Booking[]>(`/api/bookings?${queryParameters.toString()}`),
    ...options,
  });
};

export default useBookingsQuery;
